import styled from "@emotion/styled"
import React from "react"
import { sm, xs } from "../../styles/mediaQuery"

export const SmallScreenOnly: React.FC<SmallScreenComponentProps> = ({ children }) => {
  return <SmallScreenOnlyWrapper>{children}</SmallScreenOnlyWrapper>
}

interface SmallScreenComponentProps {
  children?: React.ReactNode
}

const SmallScreenOnlyWrapper = styled.div`
  display: none;

  ${xs} {
    display: block;
  }

  ${sm} {
    display: block;
  }
`
